<app-navbar-component *ngIf="isUserLoggedIn() && !areTranslationsLoading && !areBusinessRulesLoading"></app-navbar-component>
<main class="body-style"
[class.has-system-notifications]="hasSystemNotifications$ | async">
    <div class="app-pre-loader" *ngIf="areTranslationsLoading || areBusinessRulesLoading">
      Loading<span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
    </div>
    <div class="main-container" *ngIf="!areTranslationsLoading && !areBusinessRulesLoading" style="flex: 1 100%; height: 100%">
        <app-loader></app-loader>
        <router-outlet></router-outlet>
    </div>
    <chapps-request-error-modal></chapps-request-error-modal>
    <chapps-multimedia-viewer></chapps-multimedia-viewer>
    <chapps-icon-sprite-map></chapps-icon-sprite-map>
    <app-system-upgrade-screen></app-system-upgrade-screen>
    <app-debug-menu></app-debug-menu>
</main>
